export async function getTenkiLink(pref, citycode, camid) {
  const config = useRuntimeConfig()
  if (camid === '410000116') {
    return {
      text: '東京タワー',
      url: `${config.public.hostDomain}/onebox/tenki/spot/tower/03/2147312/`
    }
  } else if (camid === '7CDDE9068D9A') {
    return {
      text: '明治神宮',
      url: `${config.public.hostDomain}/onebox/tenki/spot/shrine/03/3360015/`
    }
  } else if (camid === '410001357') {
    return {
      text: '高尾山',
      url: `${config.public.hostDomain}/onebox/tenki/spot/landscape/03/1333768/`
    }
  }
  const { data: cityData } = await useFetch(`/api/tenki/cityname?citycode=${citycode}`)
  return {
    text: cityData.value ? cityData.value.name : '',
    url: `${config.public.hostDomain}/onebox/tenki/${pref}/${citycode}/`
  }
}
